import { render, staticRenderFns } from "./navigationItems.vue?vue&type=template&id=4f871560"
import script from "./navigationItems.vue?vue&type=script&lang=js"
export * from "./navigationItems.vue?vue&type=script&lang=js"
import style0 from "./navigationItems.vue?vue&type=style&index=0&id=4f871560&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductNavigationContent: require('/app/components/product/navigationContent.vue').default})
